import { Fragment } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import EditDetails from "./EditDetails";

//MUI
import MuiLink from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

//Icons
import LocationOn from "@material-ui/icons/LocationOn";
import LinkIcon from "@material-ui/icons/Link";
import CalendarToday from "@material-ui/icons/CalendarToday";
import AddAPhotoRoundedIcon from "@material-ui/icons/AddAPhotoRounded";

// custom components
import MyButton from "../../util/MyButton";

//Redux stuff
import { connect } from "react-redux";
import { uploadImage } from "../../redux/actions/userActions";

// const styles = (theme) => ({
//   paper: {
//     padding: 20,
//   },
//   profile: {
//     "& .image-wrapper": {
//       textAlign: "center",
//       position: "relative",
//     },
//     "& .profile-image": {
//       width: 200,
//       height: 200,
//       objectFit: "cover",
//       maxWidth: "100%",
//       borderRadius: "50%",
//     },
//     "& .profile-details": {
//       textAlign: "center",
//       "& span, svg": {
//         verticalAlign: "middle",
//       },
//       "& a": {
//         color: theme.palette.primary.main,
//       },
//     },
//     "& hr": {
//       border: "none",
//       margin: "0 0 10px 0",
//     },
//   },
// });

const StaticProfile = ({
  classes,
  profile: { username, createdAt, imageUrl, bio, website, location },
  uploadImage,
  user: { credentials, authenticated },
}) => {
  const handleEditPicture = () => {
    const fileInput = document.querySelector("#imageInput");
    fileInput.click();
  };

  const handleImageChange = (e) => {
    const image = e.target.files[0];
    const formData = new FormData();
    formData.append("image", image, image.name);
    uploadImage(formData);
  };

  return (
    <div className="profile-container">
      <div className="bg-cover">
        <div className="profile-img">
          <a href={imageUrl}>
            <img src={imageUrl} alt="profile" className="profile-image" />
          </a>
          {authenticated && username === credentials.username ? (
            <>
              <input
                type="file"
                id="imageInput"
                hidden="hidden"
                onChange={handleImageChange}
              />
              <MyButton
                tip="Edit Profile Picture"
                onClick={handleEditPicture}
                btnClassName="button"
              >
                <AddAPhotoRoundedIcon color="primary" />
              </MyButton>{" "}
            </>
          ) : null}
        </div>
      </div>

      <div className="details">
        <Typography style={{color:"#0f1419",fontSize:"20px",fontWeight:"800",lineHeight:"24px"}}>
          {username}
        </Typography>
        <hr />
        {bio && <Typography style={{color:"#0f1419",fontSize:"15px",fontWeight:"400",lineHeight:"24px"}}>{bio}</Typography>}
        <hr />
        {location && (
          <div className="flex">
            <LocationOn style={{fontSize:"20px"}} color="primary" /> <span style={{color:"#5b7083",fontSize:"15px",fontWeight:"400",lineHeight:"24px"}} className="date">{location}</span>
          </div>
        )}
        {website && (
          <div className="flex">
            <LinkIcon style={{fontSize:"20px"}} color="primary" />
            <a style={{fontSize:"15px"}} href={website} target="_blank" rel="noopener noreferrer">
              {website}
            </a>
            <hr />
          </div>
        )}
        <div className="flex">
          <CalendarToday style={{fontSize:"15px"}} color="primary" />
          <span style={{color:"#5b7083",fontSize:"15px",fontWeight:"400",lineHeight:"24px"}} className="date">Joined {dayjs(createdAt).format("MMM YYYY")}</span>
        </div>
        <div>
          {authenticated && username === credentials.username ? (
            <EditDetails />
          ) : null}
        </div>
      </div>
    </div>
  );
};

StaticProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  uploadImage: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapActionToProps = { uploadImage };

export default connect(mapStateToProps, mapActionToProps)(StaticProfile);
